import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Fix B (2026-08-24): 'text-base' (16px) en móvil y 'sm:text-sm' (14px) en
        // escritorio. Safari en iOS hace zoom automático sobre cualquier input con
        // fuente menor a 16px — era la causa del zoom que reportó el cliente.
        // El alto pasa a h-11 en móvil para que el campo no quede apretado con 16px.
        "flex h-11 sm:h-10 w-full rounded-[calc(var(--radius)-0.3rem)] border border-input bg-card px-3 py-2 text-base sm:text-sm text-foreground shadow-paper transition-colors duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
